import React, { useState, useEffect, useCallback } from "react";
import { Typography } from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

import Header from "../../../Header1";
import UserAvatar from "../UserAvatar";
import * as adminUserAction from "../../../../actions/admin/user";

import Loader from "../../../Utility/Loader";
import { formatValue } from "../../../../utils/utils";
import { approvalStatuses, reasons } from "../../../../utils/constants";

import UserProfileDetails from "../UserProfileDetails";
import RejectNewUserModal from "../RejectNewUserModal";
import RejectUpdateRequestModal from "../RejectUpdateRequestModal";
import ConfirmationModal from "../../../Utility/ConfirmationModal";
import { getProfileSelfieImageUrls } from "../../../../utils/serverUtils";
import { useAlert } from "../../../../Context/AlertModalContext";

const UserDetails = () => {
  const { id } = useParams();

  const alert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();

  const [details, setDetails] = useState(null);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);

  const [quesAns, setQuesAns] = useState([]);

  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [showRejectNewUserModal, setshowRejectNewUserModal] = useState(false);
  const [showRejectUpdateRequestModal, setshowRejectUpdateRequestModal] =
    useState(false);

  const [modalConfig, setModalConfig] = useState({
    show: false,
    title: "",
    message: "",
    confirmLabel: "",
    onConfirm: () => { },
  });

  const [images, setImages] = useState({
    main: null,
    first: null,
    second: null,
  });
  const [loader, setLoader] = useState(false);

  const ImageURL = useCallback(async () => {
    try {
      const response = await adminUserAction.getUserMedias(id);
      if (response) {
        const profileImages = getProfileSelfieImageUrls(response);
        setImages(profileImages);
      }
    } catch (error) {
      console.error("Error saving images:", error);
    }
  }, [id]);

  const [images2, setImages2] = useState({
    main: null,
    first: null,
    second: null,
  });

  const ImageURL2 = useCallback(async () => {
    try {
      const response = await adminUserAction.getUserMediaUpdate(id);
      if (response) {
        const profileImages = getProfileSelfieImageUrls(response);
        setImages2(profileImages);
      }
    } catch (error) {
      console.error("Error saving images:", error);
    }
  }, [id]);

  const detailsfetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await adminUserAction.getCustomerByID(id);

      // Clone the object before mutating
      const sanitizedDetails = { ...response };

      // Remove unwanted keys
      [
        "id",
        "user_id",
        "completed",
        "email_verified_at",
        "birthday",
        "gender",
        "want_gender",
        "created_at",
        "updated_at",
        "popup_promo_shown_stage",
      ].forEach(key => delete sanitizedDetails[key]);

      setDetails(sanitizedDetails);

      setLoading(false);
    } catch (err) { }
  }, [id]);

  const quesAnsfetchData = useCallback(async () => {
    try {
      const response = await adminUserAction.getUserQuestions(id);
      setQuesAns(Array.isArray(response) ? response : []);
    } catch (err) {
      console.error("Error fetching questions:", err);
      setQuesAns([]);
    }
  }, [id]);

  const GetUserFromUpdateMedia = useCallback(async () => {
    try {
      const response = await adminUserAction.getUserUpdateRequestedUser(id);
      setUpdate(response?.length !== 0);
    } catch (err) {
      console.error("Internal Server Error:", err);
    }
  }, [id]);

  const UpdateProfileapproval = async () => {
    setLoading(true);
    try {
      await adminUserAction.updateQuestionAnswers(id);
      await adminUserAction.UpdateAndDeleteOldMedia(id);
      await adminUserAction.updateUserSocket(id, {
        event: "fetch_user_data"
      });
      handleNavigate();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    quesAnsfetchData();
    detailsfetchData();
    GetUserFromUpdateMedia();
    ImageURL();
    ImageURL2();
  }, [id]);

  const updateStatus = async newStatus => {
    try {
      setLoading(true);
      await adminUserAction.updateUserStatus(
        JSON.stringify({
          id: id,
          approval: newStatus,
        })
      );
      alert.setModal({
        show: true,
        message: "Profile approved successfully",
        title: "Success",
      });
      await detailsfetchData();
      handleNavigate();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = event => {
    const selected = event.target.value;
    setSelectedReason(selected);
    setCustomReason("");
    setReason(selected);
  };

  const handleCustomReasonChange = event => {
    const customText = event.target.value;
    setCustomReason(customText);
    setSelectedReason("");
    setReason(customText);
  };

  // Reject New User Action functions
  const handleCloseRejectNewUserModal = () => {
    setReason("");
    setCustomReason("");
    setSelectedReason("");
    setshowRejectNewUserModal(false);
  };

  const handleSaveRejectNewUserModal = () => {
    updateStatusReject(30);
  };

  const updateStatusReject = async newStatus => {
    setLoading(true);
    try {
      await adminUserAction.updateUserStatus(
        JSON.stringify({
          id: id,
          approval: newStatus,
          message: reason,
        })
      );
      await adminUserAction.updateUserSocket(id, {
        event: "user_rejected",
      })
      handleCloseRejectNewUserModal();

      alert.setModal({
        show: true,
        message: "Profile rejected successfully",
        title: "Success",
      });

      navigate("/admin/user/rejected");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Reject Update Request functions
  const handleCloseRejectUpdateRequestModal = () => {
    setshowRejectUpdateRequestModal(false);
    setReason("");
  };

  const handleSaveRejectUpdateRequestModal = async () => {
    setLoader(true);
    try {
      await Promise.allSettled([
        adminUserAction.deleteMediaUpdate(id),
        adminUserAction.deleteAnswerquestions(id),
        adminUserAction.updateRejected(
          JSON.stringify({
            id: id,
            message: reason,
          })
        ),
        await adminUserAction.updateUserSocket(id, {
          event: "user_request_rejected",
        })
      ]);

      navigate("/admin/user/approval");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Delete User
  const handleDeleteRequestConfirmation = async () => {
    setModalConfig({
      show: true,
      onHide: () => setModalConfig(prev => ({ ...prev, show: false })),
      title: "Delete User",
      message: "Are you sure you want to delete this user?",
      confirmLabel: "Delete",
      onConfirm: handleDeleteRequest,
    });
  };

  const handleDeleteRequest = async () => {
    try {
      setLoading(true);
      await adminUserAction.deleteUser(
        JSON.stringify({
          id: id,
        })
      );
      handleNavigate();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = () => {
    const path = location.pathname;

    if (path.startsWith("/admin/user/approval/")) {
      navigate("/admin/user/approval");
    } else {
      navigate("/admin/user/list");
    }
  };
  if (!details) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <div className="container">
      {loading && <Loader />}
      <ConfirmationModal {...modalConfig} />
      <Header title="User Details" />
      <div className="row g-4">
        <div className="col-12 col-md-4">
          <div className="d-flex flex-column align-items-center my-3">
            <div className="mb-3 w-100">
              <UserAvatar images={images} />
            </div>

            {(images2.main || images2.first || images2.second) && (
              <>
                <h5>New Image Request</h5>
                <div className="mb-3 w-100">
                  <UserAvatar images={images2} />
                </div>
              </>
            )}

            <h5 className="text-center">
              {`${formatValue("name", details.first_name)} ${formatValue(
                "surname",
                details.last_name
              )}`}
            </h5>
            <p className="text-muted text-center">
              {formatValue(
                "status",
                approvalStatuses[details.approval] || "Unknown Status"
              )}
            </p>
          </div>
        </div>
        <div className="col-12 col-md-8">
          <UserProfileDetails details={details} />
          {/* Question & Answer Section */}
          <div className="row g-3">
            {quesAns?.length > 0 && (
              <div className="mb-4">
                <h4 className="mb-3">Question & Answers</h4>
                {quesAns.map((item, index) => (
                  <div key={index} className="mb-3">
                    <h6 className="fw-bold">{item.question}</h6>
                    <p className="mb-0">{item.answer}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* Footer Button Section */}

          <div className="row g-3 pb-3">
            <div className="d-flex flex-column align-items-center justify-content-center gap-3">
              <div className="row gy-2 justify-content-center">
                <div className="hstack gap-2 justify-content-sm-end">
                  {update && (
                    <>
                      <div className="text-center">
                        <button
                          className="btn btn-warning"
                          onClick={() => setshowRejectUpdateRequestModal(true)}
                        >
                          Request Reject
                        </button>
                      </div>
                      <div className="text-center">
                        <button
                          className="btn btn-info"
                          onClick={() => UpdateProfileapproval()}
                        >
                          Request Approve
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 pb-3">
            <div className="d-flex flex-column align-items-center justify-content-center gap-3">
              <div className="row gy-2 justify-content-center">
                <div className="hstack gap-2 justify-content-sm-end">
                  {/* Pending User */}
                  {details.approval === 10 && (
                    <>
                      <div className="text-center">
                        <button
                          className="btn btn-dark"
                          onClick={() => setshowRejectNewUserModal(true)}
                        >
                          Reject
                        </button>
                      </div>
                      <div className="text-center">
                        <button
                          className="btn btn-success"
                          onClick={() => updateStatus(20)}
                        >
                          Approve
                        </button>
                      </div>
                    </>
                  )}

                  {/* Approved User */}
                  {details.approval === 20 && !details.deleted_at && (
                    <>
                      <div className="text-center">
                        <button
                          className="btn btn-dark"
                          onClick={() => setshowRejectNewUserModal(true)}
                        >
                          Reject
                        </button>
                      </div>
                    </>
                  )}

                  {/* Rejected User */}
                  {details.approval === 30 && (
                    <div className="text-center">
                      <button
                        className="btn btn-success"
                        onClick={() => updateStatus(20)}
                      >
                        Approve
                      </button>
                    </div>
                  )}

                  {!details.deleted_at && (
                    <div className="text-center">
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDeleteRequestConfirmation()}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <RejectNewUserModal
          show={showRejectNewUserModal}
          onClose={handleCloseRejectNewUserModal}
          selectedReason={selectedReason}
          onSelectChange={handleSelectChange}
          customReason={customReason}
          onCustomReasonChange={handleCustomReasonChange}
          onSave={handleSaveRejectNewUserModal}
          reasons={reasons}
        />
        <RejectUpdateRequestModal
          show={showRejectUpdateRequestModal}
          onClose={handleCloseRejectUpdateRequestModal}
          selectedReason={selectedReason}
          onSelectChange={handleSelectChange}
          customReason={customReason}
          onCustomReasonChange={handleCustomReasonChange}
          onSave={handleSaveRejectUpdateRequestModal}
          reasons={reasons}
          loader={loader}
        />
      </div>
    </div>
  );
};

export default UserDetails;
